
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {Options} from "../utils/decorators";
import moment from '../utils/moment';

const oneMinute = 60;
const oneHour = oneMinute * 60;
const oneDay = oneHour * 24;

@Options({
    template: false,
    ui: {
    }
})

export default class VideoWithTimerView extends Marionette.View<Backbone.Model> {

    videoStartTime = null;
    interval = null;

    onRender() {
        this.$el.addClass('video-with-timer--initialized');

        if (!this.$el.data('videoStart')) {
            this.showVideo();
        } else {
            this.videoStartTime = moment(decodeURIComponent(this.$el.data('videoStart')));
            const now = moment();

            if (this.videoStartTime <= now) {
                this.showVideo();
            } else {
                const that = this;
                this.interval = setInterval(function () {that.updateCountdown();}, 250);
            }
        }
    }

    updateCountdown() {
        const now = moment();
        const diff = this.videoStartTime.diff(now, 'seconds');
        let html = '';

        if (diff <= 0) {
            clearInterval(this.interval);
            this.showVideo();
        } else {
            const daysLeft = Math.floor(diff / oneDay);
            const hoursLeft = Math.floor((diff - (oneDay * daysLeft)) / oneHour);
            const minutesLeft = Math.floor((diff - (oneDay * daysLeft + hoursLeft * oneHour)) / oneMinute);
            const secondsLeft = (diff - (oneDay * daysLeft + hoursLeft * oneHour + minutesLeft * oneMinute));

            if (daysLeft > 1) {
                html+= ` <span class="player-countdown player-countdown__days"><span class="player-countdown__count">${daysLeft}</span> <span class="player-countdown__duration">days</span></span> `;
            } else if (daysLeft) {
                html+= ` <span class="player-countdown player-countdown__days"><span class="player-countdown__count">${daysLeft}</span> <span class="player-countdown__duration">day</span></span> `;
            }

            if (hoursLeft > 1) {
                html+= ` <span class="player-countdown player-countdown__hours"><span class="player-countdown__count">${hoursLeft}</span> <span class="player-countdown__duration">hours</span></span> `;
            } else if (hoursLeft) {
                html+= ` <span class="player-countdown player-countdown__hours"><span class="player-countdown__count">${hoursLeft}</span> <span class="player-countdown__duration">hour</span></span> `;
            }

            if (minutesLeft > 1) {
                html+= ` <span class="player-countdown player-countdown__minutes"><span class="player-countdown__count">${minutesLeft}</span> <span class="player-countdown__duration">minutes</span></span> `;
            } else if (minutesLeft) {
                html+= ` <span class="player-countdown player-countdown__minutes"><span class="player-countdown__count">${minutesLeft}</span> <span class="player-countdown__duration">minute</span></span> `;
            }

            if (secondsLeft > 1) {
                html+= ` <span class="player-countdown player-countdown__seconds"><span class="player-countdown__count">${secondsLeft}</span> <span class="player-countdown__duration">seconds</span></span> `;
            } else if (secondsLeft) {
                html+= ` <span class="player-countdown player-countdown__seconds"><span class="player-countdown__count">${secondsLeft}</span> <span class="player-countdown__duration">second</span></span> `;
            }
        }

        this.$el.find('[data-timer-content]').html(html);
    }

    showVideo() {
        this.$el.addClass('show-video');
    }
}


// WEBPACK FOOTER //
// ./@modules/views/video-with-timer-view.ts